import React, { useEffect, useRef } from "react";
import OwlCarousel from "react-owl-carousel3"; 
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Appqr from '../../components/Appqr';
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./SinglesWeekendGetaway.css";

const images = [
  "assests/images/gallery-1.jpg",
  "assests/images/gallery-2.jpg",
  "assests/images/speed_dating.jpeg",
  "assests/images/single_weekend.jpeg",
  "assests/images/romantic.jpeg",
];

const experiences = [
  {
    title: "Surfing",
    image: "assests/images/ex-1.png",
    description:
      "Whether you’re brand new to surfing or a seasoned vet, our singles surf weekend is all about getting in the water, having fun, and giving it a go. We provide expert-led lessons, wetsuits, and all the equipment you need, so you can focus on catching waves and enjoying the experience.",
  },
  {
    title: "Yoga",
    image: "assests/images/ex-2.png",
    description:
      "Start your day with gentle morning yoga led by our onsite instructor. Designed for all levels, these sessions help you stretch, reset, and ease into the day ahead.",
  },
  {
    title: "Hiking",
    image: "assests/images/ex-3.png",
    description:
      "Take in incredible coastal and mountain views on a group hikes through the surrounding landscape. Fresh air, open space, and some of the most beautiful scenery the west of Ireland has to offer.",
  },
  {
    title: "Amazing Food",
    image: "assests/images/ex-4.png",
    description:
      "Enjoy hearty, home-cooked meals shared together, with evenings centred around wood-fired pizzas and relaxed dining. Good food, good company, and no rush.",
  },
];

const SinglesWeekendGetaway = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: '13%',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const carouselRef = React.useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.title = `Singles Weekend Getaway | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'weekend new';

    let metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      // Update existing meta tag
      metaRobots.setAttribute("content", "noindex, nofollow");
    } else {
      // Create new meta tag if it doesn't exist
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }

  }, []);

  return (
    <>
      <Header />

      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/weekend-d.png'}
          alt="QR Code"
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/weekend-m.png'}
          alt="QR Code"
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-5 ire-left">
            <div className="d-flex gap-2 mb-2">
              {/*<h4>June 19th - 21th</h4>*/}
              <h3>August 14 - 16th</h3>
            </div>
            <h2>Singles Surf Weekend Getaway in the West of Ireland</h2>
          </div>

          <div className="col-md-2 d-none d-md-block"></div>

          <div className="col-md-5 ire-right">
            <p>
              Your Friend, My Friend is bringing back our very popular Singles Surf Weekend Getaway in the west of Ireland, bringing together 32 singles (16 men and 16 women) for a relaxed weekend escape. Set against rugged mountains and wild Atlantic beaches, the weekend is designed to help you properly switch off and meet new people.
            </p>
            <p>
              Across two days, expect surfing, scenic hikes, home-cooked meals, evenings by the fire, and pints in the local pub. No pressure, no awkward icebreakers, just good people, fresh air, and genuine connection.
            </p>
            <span>
              Total cost for the weekend is €440 per person. Fill out the form below to be notified with spaces open up!
            </span>
            <div className="arrive-new mt-4">
              <Link to="https://forms.gle/1WHESVkHLNi9LLhx9" className="btn bros-bu text-decoration-none" target="_blank">
                Register your interest
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="hodi">
        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/weekoff.png'} className="img-fluid" alt="" />
      </div>

      {/* The Experience Section */}
      <div className="container-fluid experience">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>The experience</h2>
          <div className="d-none d-md-block">
            <button
              className="btn p-0 me-2"
              onClick={() => carouselRef.current.prev()}
            >
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png'} alt="Previous" className="carousel-control left-arrow" />
            </button>
            <button
              className="btn p-0"
              onClick={() => carouselRef.current.next()}
            >
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png'} alt="Next" className="carousel-control right-arrow" />
            </button>
          </div>
        </div>
        <div className="d-block d-md-none">
          <div className="row">
            {experiences.map((exp, index) => (
              <div key={index} className="col-xs-12 mb-4">
                <div className="card border-0">
                  <img
                    src={process.env.REACT_APP_BASE_URL + exp.image}
                    className="expi-imgs"
                    alt={exp.title}
                  />
                  <div className="card-body">
                    <h5>{exp.title}</h5>
                    <p>{exp.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="d-none d-md-block">
          <OwlCarousel
            ref={carouselRef}
            className="owl-theme experience-carousel"
            loop
            margin={20}
            nav={false}
            dots={false}
            autoplay={false}
            stagePadding={100} 
            responsive={{
              768: { items: 2 },
              1024: { items: 3 },
            }}
          >
            {experiences.map((exp, index) => (
              <div className="item" key={index}>
                <div className="card border-0">
                  <img
                    src={process.env.REACT_APP_BASE_URL + exp.image}
                    className="expi-img"
                    alt={exp.title}
                  />
                  <div className="card-body">
                    <h5>{exp.title}</h5>
                    <p>{exp.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>

      <div className="container-fluid events quick">
        <div className="row d-flex">
          <div className="col-md-4 order-1 order-md-1 d-flex flex-column flex-grow-1">
            <div className="tired">
              <h2>PLANNING</h2>
              <h4 className="mb-0">A quick outline</h4>
            </div>
            <div className="tired-2 mt-auto">
              <p>
                Arriving on Friday afternoon and leaving Sunday afternoon, you will enjoy two nights of great craic and adventure. Every room is ensuite, with all meals included, along with all daytime and evening activities. The only thing you will need to put your hand in your pocket for is a few pints at the onsite pub.
              </p>
              <Link
                to="https://forms.gle/1WHESVkHLNi9LLhx9"
                target="_blank"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                Register your interest
              </Link>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center order-2 order-md-2 flex-grow-1">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/weekend-outline.png'}
              alt="TikTok"
              className="img-fluid"
            />
          </div>
          <div className="col-md-4 d-flex align-items-end flex-grow-1 order-3 order-md-3">
            <div className="uk">
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>
                  2 nights in our shared rooms (double, triple or dorm - this will be picked at random)
                </p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>Surf lessons with wetsuit included</p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <div className="dfdf">
                  <p>Hikes with spectacular views</p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>Two morning yoga classes</p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>Two breakfasts, one lunch and two dinners</p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>Homemade snacks, tea and coffee throughout the day</p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>One hour long sauna session</p>
              </div>
              <div className="d-flex align-items-start mb-2">
                <div className="aro">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/righty.png'}
                    alt="TikTok"
                    className="mb-1"
                  />
                </div>
                <p>Evening group get togethers at the local pub</p>
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center d-md-none order-4">
            <Link
              to="https://forms.gle/1WHESVkHLNi9LLhx9"
              target="_blank"
              className="brow-bu text-decoration-none"
            >
              Register your interest
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real sparks">
        <div className="row justify-content-between">
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>YFMF</h6>
              <h2>Lodge vibes and romantic sparks</h2>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-7 pe-md-0">
            <div>
              <Slider ref={sliderRef} {...settings}>
                {images.map((img, i) => (
                  <div key={i} className={`custom-slide ${i === images.length - 1 ? 'last-slide' : ''}`}>
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "460px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="accors accordi good">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What’s included in the €440 cost?
                </Accordion.Header>
                <Accordion.Body>
                  The price includes two nights' accommodation, all meals (breakfast, lunch, dinner,
                  snacks), organised group activities, and curated mixers designed to help you connect
                  naturally with other singles.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  What’s not included in the €440 cost?
                </Accordion.Header>
                <Accordion.Body>
                  Transport to and from the venue is not included. Any additional drinks,alcohol,extras,or spending money are at your own discretion.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  What is the age range for the weekends?
                </Accordion.Header>
                <Accordion.Body>
                  The age range for the weekend will be determined by who registers. Primarily the weekend will be for those ages 25-45.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Will i have my own room?</Accordion.Header>
                <Accordion.Body>
                  Rooms are shared with others of the same gender in doubles, triples and dorms, picked at random.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>What do i need to bring?</Accordion.Header>
                <Accordion.Body>
                  The getaway takes place at Killadoon Lodge, Co. Mayo. We’ll send detailed directions closer to the event.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>How do i get there?</Accordion.Header>
                <Accordion.Body>
                  Comfortable clothes, activewear for outdoor activities, a rain jacket (just in case!), andanything personal you’ll need for the weekend.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>How do i book the getaway?</Accordion.Header>
                <Accordion.Body>
                  Due to high demand, we ’ re using a lottery system to select attendees. Fill out the form on our website to register your interest. We ’ ll send invitations to selected guests starting April 1st .
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  What is the cancelation policy?
                </Accordion.Header>
                <Accordion.Body>
                  <p className="mb-0">If you cancel your booking 21 days prior to your arrival date, you will receive a full refund.</p>  
                  <p className="mb-0">Cancelations made 20 days or less prior to arrival will receive a 50% refund.</p>  
                  <p>Cancelations made 7 days or less prior to arrival are non-refundable.</p> 
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Appqr />
      <Footer />
    </>
  );
};

export default SinglesWeekendGetaway;
